import { gql } from '@apollo/client';

const LOG_API_ERROR = gql`
  mutation logApiError($data: LogApiErrorInput!) {
    logApiError(data: $data)
  }
`;

export default LOG_API_ERROR;
